export const SELECTED_EDGE_STROKE_WIDTH = 5;
export const DESELECTED_EDGE_STROKE_WIDTH = 3;
